import React from "react";
export const getMarketingBox = () => {
  return (
    <div>
      <div
        style={{
          fontSize: "medium",
          fontWeight: "bold",
          margin: "5px",
          textAlign: "left"
        }}
      >
        <div
          style={{
            marginTop: "5px",
            padding: "10px",
            textAlign: "center"
          }}
        >
          We are continously improving to serve you better!
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/getMarketingBox.js